import React from 'react';
import clsx from 'clsx';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';

import './delete-button.scss';

/**
 * DeleteButton - Delete button is custom icon added.
 * @param {*} props
 * @returns <button>
 */
const DeleteButton = React.forwardRef((props, ref) => {
  const { className, children, fontSize = '20px', ...restProps } = props;
  return (
    <button
      ref={ref}
      className={clsx('button--unstyled', 'button--delete', className)}
      {...restProps}
    >
      {children}
      <HighlightOffIcon style={{ fontSize }} />
    </button>
  );
});

export default DeleteButton;
